import {getCurrentYear} from '../../utils/commons'
import BestReviewsLogo from './logo'
import {bestReviewsStyles} from './styles'

const baseConfig = {
  domainName: 'bestreviews' as const,
  domainType: 'brg' as const,
  camelCaseUrl: 'BestReviews.guide',
  siteName: 'Best Reviews Guide',
  logo: <BestReviewsLogo />,
  favicon: '/favicons/bestreviews.png',
  styles: bestReviewsStyles,
}

const localeConfigs = {
  us: {
    measurementId: 'G-NRXERHC5MC',
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in the US | There's One Clear Winner | BestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `BestReviews.guide analyzes thousands of articles and customer reviews to find the top-rated products at today's lowest prices. Best products, best offers.`,
  },
  uk: {
    measurementId: 'G-14N6P0KZFE',
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in the UK | There's One Clear Winner | BestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `BestReviews.guide analyzes thousands of articles and customer reviews to find the top-rated products at today's lowest prices. Best products, best offers.`,
  },
  au: {
    measurementId: 'G-GP05J4N65V',
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in Australia | There's One Clear Winner | BestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `BestReviews.guide analyzes thousands of articles and customer reviews to find the top-rated products at today's lowest prices. Best products, best offers.`,
  },
  ca: {
    measurementId: 'G-ZDVEXR29KG',
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in CA | There's One Clear Winner | BestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `BestReviews.guide analyzes thousands of articles and customer reviews to find the top-rated products at today's lowest prices. Best products, best offers.`,
  },
  in: {
    measurementId: 'G-BW3MX66W8R',
    title: (category: string, count: string) =>
      `${count} Best ${category} ${getCurrentYear()} in India | There's One Clear Winner | BestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `BestReviews.guide analyzes thousands of articles and customer reviews to find the top-rated products at today's lowest prices. Best products, best offers.`,
  },

  fr: {
    measurementId: 'G-B2KF8GN4B9',
    title: (category: string, count: string) =>
      `${count} Meilleur ${category} de ${getCurrentYear()} en FR | Il y a un gagnant incontestable | BestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `BestReviews.guide analyse des milliers d'articles et d'avis clients pour trouver les produits les mieux notés aux prix les plus bas du jour. Les meilleurs produits, les meilleures offres.`,
  },
  it: {
    measurementId: 'G-CJG3874H1S',
    title: (category: string, count: string) =>
      `${count} Migliori ${category} ${getCurrentYear()} in IT | Abbiamo un chiaro vincitore | BestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `BestReviews.guide analizza migliaia di articoli e recensioni dei clienti per trovare i prodotti più quotati ai prezzi più bassi di oggi. I migliori prodotti, le migliori offerte.`,
  },
  es: {
    measurementId: 'G-TGGK82LSVH',
    title: (category: string, count: string) =>
      `${count} Lo mejor en ${category} de ${getCurrentYear()} en ES | Hay un claro ganador | BestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `BestReviews.guide analiza miles de artículos y reseñas de clientes para encontrar los productos mejor valorados a los precios más bajos. Los mejores productos, las mejores ofertas.`,
  },
  de: {
    measurementId: 'G-CZFS58MCDM',
    title: (category: string, count: string) =>
      `${count} Beste ${category} ${getCurrentYear()} in DE | Es gibt einen klaren Gewinner | BestReviews.guide`,
    description: (_category?: string, _count?: string) =>
      `BestReviews.guide analysiert Tausende von Artikeln und Kundenrezensionen, um die am besten bewerteten Produkte zu den derzeit niedrigsten Preisen zu finden. Beste Produkte, beste Angebote.`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
